import { makeStyles } from '@material-ui/core/styles';
import { buttonAddStyles, buttonPrimaryStyles, buttonDeleteStyles } from 'shared/Buttons/button.styles';

export const useEditUserStyles = makeStyles(theme => ({
  formOverride: {
    '& form': {
      padding: 'unset',
      background: 'unset',
      boxShadow: 'unset',
      borderRadius: 'unset'
    }
  },
  buttonAdd: {
    ...buttonAddStyles
  },
  buttonBack: {
    ...buttonPrimaryStyles
  },
  buttonDelete: {
    ...buttonDeleteStyles
  }
}));
